module.exports = __webpack_public_path__ + "static/media/invoicelogo.5381aa91.png";